import { jsx } from "react/jsx-runtime";
import { useInView } from "../../../../hooks/index.js";
import { observedThresholds } from "../utils/observedThresholds.js";
function Canary(props) {
  const { viewport, onChange, rect } = props;
  const { top = 0, left = 0, height = 0, width = 0 } = rect ?? {};
  const { ref } = useInView({
    onChange,
    root: viewport,
    threshold: observedThresholds
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "truncate-list-canary",
      "data-testid": "truncate-list_canary-more",
      ref,
      style: {
        height,
        left,
        pointerEvents: "none",
        position: "absolute",
        top,
        visibility: "hidden",
        width,
        zIndex: 10
      }
    }
  );
}
export {
  Canary
};
//# sourceMappingURL=Canary.js.map
